/**
 * Shared button styles used across all dashboard and list pages.
 * Reference height: export-patients-dialog Submit button (variant="outlined" size="small")
 * All buttons use size="small" MUI prop — no explicit height override.
 */
import { StyleRules } from '@mui/styles'

const dashboardStylesheet: StyleRules = {
  // ── Base — font/icon sizing for dashboard buttons (bg/color from global baseStyles) ─
  btn: {
    fontSize: '0.65rem !important',
    '& .MuiButton-startIcon': {
      marginRight: '4px !important',
      marginLeft: '0px !important',
      color: 'inherit !important',
      '& .MuiSvgIcon-root': {
        fontSize: '0.75rem !important',
      },
      '& .MuiCircularProgress-root': {
        width: '0.75rem !important',
        height: '0.75rem !important',
      },
    },
  },

  // ── Primary — marker class; bg/color handled by global (light: themes.tsx, dark: App.tsx) ─
  btnPrimary: {},

  // ── Disabled — subtle bg + not-allowed cursor (overrides global active style) ─
  disabledBtn: {
    backgroundColor: 'var(--color-background-subtle) !important',
    color: 'var(--color-text-primary) !important',
    borderColor: 'var(--color-border-medium) !important',
    cursor: 'not-allowed',
    opacity: '0.6 !important',
  },
}

export default dashboardStylesheet

// ── Dark mode global button overrides (injected via GlobalStyles in App.tsx) ─
// Exported separately so App.tsx doesn't need to define button styles inline.
// These override commonStyles (which sets orange for both modes) because
// darkModeStyles is spread AFTER commonStyles in App.tsx GlobalStyles.
// darkModeButtonStyles is now minimal — global button styles live in baseStyles (App.tsx)
// using CSS vars that auto-adapt per mode. Only truly dark-specific non-button overrides here.
export const darkModeButtonStyles = {}
